import { Component, OnInit } from '@angular/core';
import { Expense } from '../expense';
import { ActivatedRoute } from '@angular/router';
import { ExpenseService } from '../expense.service';
import { ExpenseTypeService } from '../../expense_types/expense-type.service';
import { GlobalDataService } from '../../../../services/global-data.service';
import { NgForm } from '@angular/forms';
import { Message } from 'primeng/primeng';
import { SelectItem } from 'primeng/primeng';
import {InputTextareaModule} from 'primeng/primeng';

@Component({
  selector: 'app-expense-crud',
  templateUrl: './expense-crud.component.html',
  styleUrls: ['./expense-crud.component.css'],
  providers: [ExpenseService,ExpenseTypeService]
})
export class ExpenseCrudComponent implements OnInit {

  id: any = null;
  expenses: Expense;
  msgs: Message[] = [];
  selectedItemByID: string;
  store_id: any;
  button_caption: string ="Сохранить"
  button_icon:string ="fa fa-save";

  constructor(private expenseService: ExpenseService,
              private expenseTypeService: ExpenseTypeService,
              private activatedRoute: ActivatedRoute,
              private global: GlobalDataService) { 
  	 		 activatedRoute.params.subscribe(params=>{this.id=params['id']});

   		  if(this.id){

   		  				this.expenseTypeService.getExpenseType().subscribe(response=>{this.expenses.expense_types=response['data'].map(function(value: any){
	    			    return {label:value.name, value: value.id};
	  				});})


   		  			this.expenseService.getExpenseById(this.id).subscribe(response=>{
   		  			   	let tmp = response['data'].expense_type_id;
   		  		    //	response['data'].store_types=null;
   		  				this.expenses=response['data'];

   		  			
   		  						this.expenseTypeService.getExpenseType().subscribe(response=>{this.expenses.expense_types=response['data'].map(function(value: any){
	    			    return {label:value.name, value: value.id};
	  				});})
   		  						 this.selectedItemByID=tmp;
   		  			});	

   		  	

   		  			

   		 			this.button_caption="Редактировать";
   		 			this.button_icon="fa fa-edit";
   		  }else{
					this.expenseTypeService.getExpenseType().subscribe(response=>{this.expenses.expense_types=response['data'].map(function(value: any){
	    			    return {label:value.name, value: value.id};
	  				});})
   		  }

   }

  ngOnInit() {

     // this.store_id=this.global.user.stores[0].id;

  	 this.expenses = {
			id: "",
			name: "",
			amount: "",
			description: "",
			expense_types: [],
			available: false
  	 }
  }

  crud(form: NgForm):void{

   		  if(!this.id){
   		  		this.expenseService.createExpense(form.value)
   		  		.subscribe((data) => {this.msgs.push({severity:'success', summary:'Сообщение', detail: "Успешно: "+data});console.log(data);}
                  , (error)=>{let str="";for (var key in JSON.parse(error._body).errors) {str+="\n" +JSON.parse(error._body).errors[key][0];} ;this.msgs.push({severity:'error', summary:'Сообщение', detail: "Ошибка: "+str});console.log(JSON.parse(error._body)); });

   		  }else{
   		  	this.expenseService.updateExpense(form.value,this.id)
   		  		.subscribe((data) => {this.msgs.push({severity:'success', summary:'Сообщение', detail: "Успешно: "+data});console.log(data);}
                  , (error)=>{let str="";for (var key in JSON.parse(error._body).errors) {str+="\n" +JSON.parse(error._body).errors[key][0];} ;this.msgs.push({severity:'error', summary:'Сообщение', detail: "Ошибка: "+str});console.log(JSON.parse(error._body));});
   		  }



  }	 

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/expenses/expense-crud/expense-crud.component.ts